'use client';
import { useEffect } from 'react';
import HomeHeader from './components/home/HomeHeader';
import FeaturesSection from './components/home/FeaturesSection';
import WhyChooseSection from './components/home/WhyChooseSection';
import BuildForSection from './components/home/BuildForSection';
import IntegrationSection from './components/home/IntegrationSection';
import TaxCalculator from './components/home/TaxCalculator';
// import FAQSection from './components/home/FaqSection';
import CustomerReview from './components/home/CustomerReview'
import HomeFooter from './components/home/HomeFooter';

export default function Home() {
  useEffect(() => {
    const slider = document.getElementById('slider') as HTMLInputElement;
    const sliderValue = document.getElementById('sliderValue');
    const perMonth = document.getElementById('per-month');
    const perYear = document.getElementById('per-year');

    function updatePrice() {
      if (slider && perMonth && perYear) {
        const value = parseInt(slider.value);
        const newPricePerMonth = value * 1000;
        const newPricePerYear = newPricePerMonth * 12;
        perMonth.textContent = "₦" + newPricePerMonth.toString();
        perYear.textContent = "₦" + newPricePerYear.toString();
      }
    }

    if (slider) {
      slider.addEventListener('input', function () {
        if (sliderValue) sliderValue.textContent = slider.value;
        updatePrice();
      });
    }

    // Initialize price
    updatePrice();

    return () => {
      if (slider) {
        slider.removeEventListener('input', updatePrice);
      }
    };
  }, []);

  return (
      <div className="container-fluid">
        {/* Header section */}
        <HomeHeader />

        {/* First section */}
        <FeaturesSection />

        {/* Second section */}
        <WhyChooseSection />

        {/* Third section */}
        <BuildForSection />

        {/* Grow section */}
        <IntegrationSection />

        {/* Pricing section */}
        <TaxCalculator />

        {/* FAQ section */}
        {/* <FAQSection /> */}

        {/* Try it */}
        <CustomerReview />
      </div>
  );
}